export const NEWS_ITEMS = [
  {
    date: '2026-08-25',
    text: 'Added unit on backpropagation and initialization.',
  },
    {
    date: '2026-08-17',
    text: 'Added unit on fitting models',
  },
      {
    date: '2026-06-29',
    text: 'Added unit on loss functions',
  },
  {
    date: '2026-06-18',
    text: 'Back end of website reworked.  Added highlighting ability.',
  },
  {
    date: '2026-05-08',
    text: 'Front end of website reworked.  Added news sections.  Added more details on course overview pages.',
  },
  {
    date: '2026-05-02',
    text: 'Added unit to probability section on expectation.',
  },
{
    date: '2026-04-10',
    text: 'First version of IClimbTrees made public with seven modules on machine learning, probability, and SAT solvers.',
  },
];

/** @param {string} iso */
export function formatDate(iso) {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}
